import { useMutation } from "@apollo/client";
import { DeleteDialog } from "components/DeleteDialog";
import useText from "constants/text";
import { useAlertDispatch } from "contexts/AlertContext";
import { ParcelOrderStoreContext } from "contexts/ParcelsDataContext";
import { ParcelActionType } from "data/types";
import { DELETE_PARCEL } from "domains/Task/graphql/mutations";
import React from "react";

interface ParcelDeletionProps {
  id: String;
  isOpenDialog: boolean;
  CloseDialog: () => void;
  refetch:() => void;
}

export const DeleteParcel = ({ id, isOpenDialog,refetch, CloseDialog }: ParcelDeletionProps) => {
  const { text } = useText();
  const dispatchAlert = useAlertDispatch();
  const [deleteParcel] = useMutation(DELETE_PARCEL);
  const [, dispatcher] = React.useContext(ParcelOrderStoreContext);

  const handleDelete = async () => {
    await deleteParcel({
      variables: {
        parcelID: id,
      },
    })
      .then((result) => {
        const { data, message } = result?.data?.deleteParcel;
        dispatchAlert({
          severity: data ? "success" : "error",
          message,
        });
        dispatcher({
          type: ParcelActionType.RemoveParcels,
          data: [{ _id: id }],
        });
        setTimeout(CloseDialog, 1500);
      })
      .catch((error) => {
        dispatchAlert({
          severity: "error",
          message: error.message,
        });
        setTimeout(CloseDialog, 1500);
      });
      refetch();
  };
  return (
    <DeleteDialog
      title={text.parcel.parcel_deletion}
      message="Are you sure you want to delete this parcel ?"
      open={isOpenDialog}
      handlerCancel={CloseDialog}
      handlerConfirm={handleDelete}
    />
  );
};
export default DeleteParcel;
